module.exports = {
	"about": {
		"title": "About Us"
	},
	"account": {
		"button": {
			"passwordDone": "Email sent",
			"passwordReset": "Send Email",
			"remove": "Remove",
			"update": "Update"
		},
		"confirmation": {
			"password": "Email sent to %{email}",
			"profile": "Your profile was successfully updated"
		},
		"cookies": {
			"disable": "Disable Cookies",
			"enable": "Enable Cookies",
			"text": "You can enable/disable your cookie settings. By enabling your cookies you will receive the optimal user experience. Disabling cookies loses some website functionality.",
			"title": "Cookie Settings"
		},
		"download": {
			"button": "Download",
			"description": "You can export and download your RareConnect data including all comments, posts, and profile information.",
			"dialog": {
				"button": "Save",
				"title": {
					"loading": "Please wait while we fetch your data",
					"ready": "Your data is ready to download"
				}
			},
			"title": "Download My Data"
		},
		"error": {
			"password": "A reset password could not be set at this time. Please ensure your email is verified.",
			"profile": "Your profile could not be updated at this time"
		},
		"field": {
			"email": "Email",
			"username": "Username"
		},
		"password": {
			"description": "Request a reset password email to be sent to your verified email address.",
			"title": "Password"
		},
		"preferences": {
			"emailNotifications": {
				"comment": {
					"label": "Email me when a user has commented on my content"
				},
				"commentThread": {
					"label": "Email me when a user has contributed to a discussion I have also commented on"
				},
				"error": {
					"notVerified": "A verified email is required to adjust email notification preferences."
				},
				"follow": {
					"label": "Email me when a user has started following me"
				},
				"joinSubscribedCommunity": {
					"label": "Email me when a user joins a community I am subscribed to"
				},
				"like": {
					"label": "Email me when a user likes my content"
				},
				"postInSubscribedCommunity": {
					"label": "Email me when a user posts in a community I am subscribed to"
				},
				"postToFollowers": {
					"label": "Email me when a user I am following posts in a community"
				},
				"storyToFollowers": {
					"label": "Email me when a user I am following posts a story"
				},
				"subtitle": "You will still receive on-site notifications even if email notifications are disabled.",
				"title": "Notifications"
			},
			"messaging": {
				"contactByEmail": {
					"label": "Allow users to message me through RareConnect"
				},
				"title": "Messaging"
			},
			"title": "Email Preferences",
			"unsubscribe": {
				"label": "I don’t want to receive notification emails",
				"title": "Unsubscribe"
			}
		},
		"profile": {
			"description": "Update your email and username. You can use both to log in to RareConnect. Your email address must be verified before you can reset your password.",
			"title": "Profile"
		},
		"remove": {
			"description": "This will remove your account from RareConnect. You will be asked to confirm prior to removal.",
			"dialog": {
				"buttons": {
					"cancel": "Cancel",
					"remove": "Remove"
				},
				"checkbox": "Remove all my content",
				"description": "Removing your account will remove your profile from RareConnect. Your posts, comments, and stories provide an excellent resource for other members. If you would like to remove all your posted content please check the box below.",
				"title": "Remove My Account"
			},
			"success": "Your account has been successfully removed.",
			"title": "Remove My Account",
			"working": "Please wait while we remove your account."
		},
		"title": "Account Settings"
	},
	"announcements": {
		"description": "Welcome to the announcements page, below you'll find posts of important events, new features, and other platform updates. If you have questions or comments, don't hesitate to comment or contact us directly at %{email}",
		"postType": "Announcement",
		"title": "Announcements"
	},
	"banners": {
		"actions": {
			"dismiss": "Dismiss"
		},
		"emailVerification": {
			"failure": "A new verification email could not be sent at this time, please contact admin@rareconnect.org for assistance.",
			"label": "Please confirm your email address by clicking the link in the email we sent to you. You will not receive email notifications until you have verified your email.",
			"link": "Resend",
			"success": "A new verification email has been sent to: %{email}. Please click the link provided to confirm your email address."
		},
		"translations": {
			"label": "We’re in the process of translating the new site into English. Thank you for your patience."
		}
	},
	"breadcrumbs": {
		"comment": {
			"description": "You are viewing a single comment to a post.",
			"link": "View post and comments"
		},
		"communities": "Communities",
		"faqs": "FAQs",
		"forum": "Updates",
		"resources": "Resources",
		"story": "Stories"
	},
	"comment": {
		"activityContainer": {
			"commented": "%{username} commented on ",
			"postAuthor": "originally posted by ",
			"viewPost": "View all",
			"you": "You"
		},
		"language": {
			"original": "originally written in %{lang}"
		},
		"menu": {
			"bookmark": {
				"add": {
					"label": "Bookmark Comment"
				},
				"remove": {
					"label": "Unbookmark Comment"
				}
			},
			"delete": "Delete Comment",
			"edit": "Edit Comment",
			"move": "Move Comment",
			"report": "Report Comment"
		}
	},
	"communities": {
		"create": {
			"request": {
				"description": "**RareConnect.org** responds to rare disease patients’ need for information and connection by creating international online communities and discussion groups for specific diseases.\n\n### Basics of creating a community with RareConnect\n- We create online communities in 12 languages for rare disease patient groups, in partnership with these groups. When there are no patient support groups, we work with individuals interested in rare diseases.\n- Representatives from the patient groups or the individuals act as moderators on the community and keep it active and updated on their groups' activities.\n- RareConnect supports the creation, maintenance and growth of the communities. This is mainly in the form of 3 dedicated community managers and all related project costs like translation, hosting, and technical bug fixes.\n\n### Step 1: Send us Basic information about the disease\n- We need to add initial information to the community:\n - Disease Name\n - Disease description (Orphanet is usually a good source)\n - Any article, FAQ, link, useful information about the disease\n\n### Step 2: Create a profile\n- Register to RareConnect and join the community. You can also register your patient organization if you belong to one. Fill in the profile to make sure others can identify you and add your location if you wish to appear on the community map.\n- Post a welcome message on the Updates section or share your story\n\n### Step 3: Promotion and Maintenance\n- Add a link to the community on your website. Share a link on your social media and in any other groups you are part of.\n- We promote the community: on RareConnect social media, on EURORDIS eNews and any other methods that help better inform people living with a rare disease.\n\n### To keep the community thriving and another part of your patient advocacy efforts:\n- keep an active moderator\n- update the community on activities, events, research\n- provide feedback to RareConnect team\n- answer questions from community members\n- continuously promote the community in your communication materials and social media\n- link to the community on your website\n- inform the scientific community\n- organize a webinar with us\n- invite us to present the community at your conference\n\n**Questions? We are waiting to talk to you: [info@rareconnect.org](mailto:info@rareconnect.org)**",
				"empty": "Are we missing your community? In just a few short steps you can request a new community from the RareConnect Team",
				"footer": "Can't find the community you're looking for?",
				"link": "Request a new community",
				"title": "Steps in creating a community on RareConnect"
			}
		},
		"description": "RareConnect responds to rare disease patients’ need for information and connection by creating international online communities and discussion groups for specific diseases. Explore communities below to join the discussions.",
		"header": {
			"all": "All communities",
			"yours": {
				"placeholder": "You’re currently not a member of any communities. All communities you join will be listed here.",
				"title": "Your communities"
			}
		},
		"link": {
			"stories": "Share a story"
		},
		"title": {
			"": "Welcome %{username}",
			"loggedIn": "Welcome %{username}",
			"notLoggedIn": "Find your community"
		}
	},
	"community": {
		"edit": {
			"failure": "Failed to update community",
			"label": "Edit Community",
			"original": {
				"description": "The original content will be displayed if a translation is unavailable",
				"fields": {
					"description": "Description",
					"language": "Language (two letter code)",
					"name": "Name"
				},
				"header": "Edit original content"
			},
			"success": "Successfully updated community",
			"title": "Edit Community - %{communityName}",
			"translation": {
				"description": "Please save after updating any of the fields below",
				"fields": {
					"description": "Translated Description",
					"language": "Translation Language",
					"name": "Translated Name"
				},
				"header": "Edit translations"
			}
		},
		"notifications": {
			"default": "Start a discussion",
			"members": {
				"multiple": "new members",
				"single": "new member"
			},
			"posts": {
				"multiple": "new posts",
				"single": "new post"
			}
		},
		"notifyMembers": {
			"action": "Join",
			"description": "After you join the community a notification is sent out to the members to let them know someone new has joined that they can connect with. It is especially useful for those rare disease communities where only a few cases are known. This notification will include your username and link to your profile.",
			"no": "No, don't notify members",
			"title": "Notify Members",
			"yes": "Yes, notify members"
		},
		"summary": {
			"join": {
				"error": "Failed to join the community",
				"label": "Join community",
				"success": "Successfully joined the community"
			},
			"leave": {
				"error": "Failed to leave the community",
				"label": "Leave community",
				"success": "Successfully left the community"
			},
			"less": "Read Less",
			"more": "Read More",
			"official": "Official Community",
			"private": "Private Community",
			"search": "Search within the community",
			"stats": {
				"members": "Members",
				"moderators": "Moderators",
				"organizations": "Patient Organizations",
				"posts": "Posts"
			},
			"subscription": {
				"emailPrefs": "Email preferences",
				"notSubscribed": "Joined",
				"subscribe": {
					"error": "Failed to subscribe",
					"label": "Subscribe",
					"success": "Successfully subscribed"
				},
				"subscribed": "Joined & Subscribed",
				"unsubscribe": {
					"error": "Failed to unsubscribe",
					"label": "Unsubscribe",
					"success": "Successfully unsubscribed"
				}
			}
		},
		"tabs": {
			"announcements": {
				"empty": "No new announcements",
				"label": "Announcements"
			},
			"faqs": {
				"empty": "There are currently no FAQs for this community. If you know a trusted website that has some FAQs about this disease, please send us the link at team@rareconnect.org",
				"label": "FAQs"
			},
			"invitations": {
				"columns": {
					"code": "Code",
					"createdAt": "Created At",
					"remove": "Remove",
					"status": "Status",
					"user": "User"
				},
				"dialog": {
					"cancel": "Cancel",
					"remove": {
						"confirm": "Are you sure you want to remove this invitation?",
						"remove": "Remove",
						"title": "Remove Invitation"
					}
				},
				"label": "Invitations",
				"status": {
					"available": "Available",
					"used": "Used"
				},
				"tooltips": {
					"add": "Create an invitation"
				}
			},
			"members": {
				"empty": {
					"members": "There are no members in this community yet.",
					"moderators": "There are no moderators in this community yet.",
					"organizations": "There are no organizations in this community yet."
				},
				"label": "Members",
				"list": {
					"members": "Members",
					"moderators": "Moderators",
					"organizations": "Organizations"
				},
				"login": "login to view more",
				"map": {
					"cluster": {
						"area": "%{number} Members in this area",
						"location": "%{number} Members in %{location}"
					},
					"error": "Unable to display map",
					"legend": {
						"members": "Members",
						"moderators": "Moderators",
						"organizations": "Organizations"
					},
					"pin": {
						"button": "Pin My Location",
						"description": "By adding your location to the map, your location will be visible to other members. This will make it easier to grow the network of people near you that are facing similar experiences.",
						"error": "Failed to save location",
						"noResults": "No results found for '%{query}'",
						"success": "Location saved",
						"title": "Pin Yourself on the Map"
					}
				},
				"search": {
					"placeholder": "Search",
					"results": {
						"many": "%{total} results found for '%{query}'",
						"none": "No results found for '%{query}'",
						"one": "One result found for '%{query}'"
					}
				}
			},
			"resources": {
				"empty": "This community currently has no resources.  If you’d like to suggest a resource or would like more information about the community, please contact team@rareconnect.org",
				"label": "Resources"
			},
			"stories": {
				"empty": "There are no stories from members of this community",
				"header": "Latest Member Stories",
				"label": "Stories"
			},
			"updates": {
				"empty": "Be the first to start a discussion by posting in this community",
				"label": "Updates",
				"sort": {
					"hot": {
						"description": "Recently-created trending posts",
						"label": "Hot"
					},
					"label": "Sort by:",
					"new": {
						"description": "The latest posts",
						"label": "New"
					},
					"top": {
						"description": "Posts with the most activity",
						"label": "Top"
					},
					"unanswered": {
						"description": "Posts that have not been answered",
						"label": "Unanswered"
					}
				}
			}
		}
	},
	"communityInvitations": {
		"errors": {
			"invalidInvite": "%{code} is not a valid invitation code",
			"missingInvite": "missing required invitation code",
			"usedInvite": "that invite has already been used"
		},
		"header": "You were invited to join the following community:",
		"requiredLogin": "Please sign up or login to join this community."
	},
	"cookies": {
		"banner": {
			"accept": "Enable",
			"decline": "Disable",
			"link": "Learn more",
			"text": "This website uses cookies to ensure you get the best experience on our website."
		},
		"contact": {
			"accept": "Enable",
			"decline": "Close",
			"text": "You have not agreed to the RareConnect.org cookie policy. This function is dependent on the use of cookies from a third-party. You can either enable cookies to use the form or contact info@rareconnect.org.",
			"title": "Cookies Disabled"
		},
		"login": {
			"accept": "Enable",
			"decline": "Close",
			"text": "You have not agreed to the RareConnect.org cookie policy. Logging in through Google or Facebook requires the use of cookies. You are still able to login with your RareConnect username/email and password, or you can either enable cookies to use the form or contact info@rareconnect.org.",
			"title": "Cookies Disabled"
		},
		"sign-up": {
			"accept": "Enable",
			"decline": "Close",
			"text": "RareConnect.org signup uses an external service whose cookies we are unable to disable. After signup however, cookies can be disabled. You have indicated that you do not accept our cookie policy. Unfortunately, that means  you are unable to signup for RareConnect.org at this time. If you change your mind in the future, you will be able to disable cookies after signup.",
			"title": "Cookies Disabled"
		}
	},
	"emailMessages": {
		"contact": {
			"button": "Message"
		},
		"disclosure": {
			"sending": "Responses to this message will be received by email. By sending this message, you are agreeing to share your email address with this user. Based on the personal nature of email addresses, it may be possible for this user to identify you. Please note that you may only send a maximum of 10 messages per day."
		},
		"error": {
			"emptyMessage": "Please include a message",
			"general": "Error sending message",
			"limitExceeded": "Exceeded daily message limit",
			"unVerified": "Please verify your email"
		},
		"message": {
			"label": "Message"
		},
		"replyTo": {
			"label": "Enter your email address"
		},
		"subject": {
			"label": "Subject",
			"value": "RareConnect: Message from %{username}"
		},
		"submit": {
			"label": "Send"
		},
		"success": "Successfully sent message",
		"title": "Send a private message to %{username}"
	},
	"error": {
		"badRequest": "Bad Request",
		"forbidden": "Sorry, you don't have permission to view this page",
		"notFound": "Oops! We can't find the page you're looking for.",
		"private": {
			"comment": "This comment is private. If you are having trouble please contact the RareConnect team for more information.",
			"community": "This community is private. If you are having trouble please contact the RareConnect team for more information.",
			"post": "This post is private. If you are having trouble please contact the RareConnect team for more information."
		},
		"unauthorized": {
			"label": "This content is for RareConnect members only.",
			"link": "Please log in to continue"
		}
	},
	"form": {
		"charLimit": "You have reached the maximum character limit (%{charLimit})",
		"comment": {
			"body": {
				"missing": "The comment text cannot be empty"
			},
			"create": {
				"error": "Failed to create new comment",
				"success": "Successfully created new comment"
			},
			"edit": {
				"add": {
					"button": "Add"
				},
				"body": {
					"hint": "Body",
					"missing": "Please include a body"
				},
				"cancel": {
					"button": "Cancel"
				},
				"language": {
					"add": "Add new translation",
					"original": "Edit the original comment",
					"translation": "Edit the %{language} translation"
				},
				"save": {
					"button": "Save"
				}
			},
			"prompt": "Reply to @%{username}",
			"submit": "Comment",
			"unauthorizedMember": "Please join the community before commenting on a post"
		},
		"date": {
			"day": "Day",
			"month": "Month",
			"year": "Year"
		},
		"post": {
			"create": {
				"error": "Failed to create new post",
				"success": "Successfully created new post"
			},
			"edit": {
				"body": {
					"hint": "Body",
					"missing": "Please include a body"
				},
				"cancel": {
					"button": "Cancel"
				},
				"language": {
					"original": "Edit the original post",
					"translation": "Edit the %{language} translation"
				},
				"save": {
					"button": "Save"
				},
				"title": {
					"hint": "Title (optional)"
				},
				"visibility": {
					"label": "Visibility:"
				}
			},
			"faq": {
				"body": {
					"missing": "The post text cannot be empty"
				}
			},
			"forum": {
				"body": {
					"label": "Share your thoughts",
					"missing": "The post text cannot be empty"
				},
				"submit": "Post",
				"title": {
					"label": "Title (optional)",
					"missing": "Please give your post a descriptive title"
				}
			},
			"resource": {
				"body": {
					"label": "Post a resource",
					"missing": "The resource content cannot be empty"
				},
				"submit": "Create",
				"title": {
					"label": "Title",
					"missing": "Please give your resource a descriptive title"
				}
			},
			"story": {
				"body": {
					"label": "Tell us your story",
					"missing": "Please include a body for your story"
				},
				"submit": "Publish",
				"title": {
					"label": "Title (optional)",
					"missing": "Please give your story a descriptive title"
				}
			},
			"unauthorized": {
				"notLoggedIn": {
					"description": "Join this community to share experiences, ask questions and connect with others in a similar position. RareConnect respects and protects the privacy of its members making the discussions only visible to registered users.",
					"title": "Most conversations in this community are for members only"
				}
			},
			"unauthorizedMember": "Please join the community before posting",
			"visibility": {
				"global": {
					"disclaimer": "If you choose to make your post visibility setting public, you understand that your content can be searched for and accessed by individuals who are not registered members of RareConnect.",
					"label": "Public",
					"menuItem": "Public (including Google)"
				},
				"private": {
					"disclaimer": "Visibility of posts in this community will be restricted to invited members only."
				},
				"users": {
					"label": "Registered users",
					"menuItem": "Other RareConnect users"
				}
			}
		}
	},
	"home": {
		"login": {
			"button": "Login"
		},
		"signup": {
			"button": "Sign up"
		}
	},
	"landing": {
		"contact": {
			"cancel": "Cancel",
			"description": "We’re excited to hear from you! Please send questions, comments, or feedback to",
			"error": {
				"email": "Error: invalid email",
				"message": "Error: message can not be empty",
				"subject": "Error: subject can not be empty"
			},
			"title": "Contact Us"
		},
		"footer": {
			"about": "About",
			"announcements": "Announcements",
			"communities": "Communities",
			"contact": "Contact",
			"privacy": "Privacy Policy",
			"terms": "Terms of Service"
		},
		"photos": {
			"slide1": {
				"description": "Weronika, from Poland, living with Gangliosidosis GM1. Photo courtesy of EURORDIS Photo Contest."
			},
			"slide10": {
				"description": "Timo, from Sweden, living with Aortic Dissection. Photo courtesy of EURORDIS Photo Contest."
			},
			"slide2": {
				"description": "Gabriel, from Malta, living with a Leukodystrophy. Photo courtesy of EURORDIS Photo Contest."
			},
			"slide3": {
				"description": "Daniel, from Russia, living with Williams Syndrome. Photo courtesy of EURORDIS Photo Contest."
			},
			"slide4": {
				"description": "Jeannette and her son Felix, from Austria, who suffer from Tuberous sclerosis. Photo courtesy of EURORDIS Photo Contest."
			},
			"slide5": {
				"description": "Malo, from France, living with Dubowitz Syndrome. Photo courtesy of EURORDIS Photo Contest."
			},
			"slide6": {
				"description": "Daniel, from Spain, living with Sanfilippo Syndrome (MPSIII). Photo courtesy of EURORDIS Photo Contest."
			},
			"slide7": {
				"description": "Sunna lives in Reykjavik, Iceland, and suffers from Alternating Hemiplegia of Childhood (AHC). Photo courtesy of EURORDIS Photo Contest."
			},
			"slide8": {
				"description": "Image from the \"Breath of Hope\" Campaign that aims to raise awareness of Idiopathic Pulmonary Fibrosis. Photo courtesy of EURORDIS Photo Contest."
			},
			"slide9": {
				"description": "Eva and Kristian, from Germany, two friends with Williams Syndrome. Photo courtesy of EURORDIS Photo Contest."
			}
		},
		"section": {
			"about": {
				"description": "A safe, easy to use platform where rare disease patients, families and patient organizations can develop online communities and conversations across continents and languages. RareConnect partners with the world's leading rare disease patient groups to offer global online communities allowing people to connect around issues which affect them while living with a rare disease.",
				"readMore": {
					"button": "Read More"
				},
				"title": "About RareConnect"
			},
			"features": {
				"caption": "RareConnect offers it’s users a unique experience due to the platforms disease specific online communities around topics of interest which may be disease specific or concern issues which touch on many disease areas.",
				"communities": {
					"description": "RareConnect includes disease-specific online communities that enable people living with rare diseases to meet, share stories and learn from each other. Communities are created in partnership with patient groups who bring resources such as moderators, relationships with specialists and validated information. Find a community above using the search box or visit our list of communities.",
					"title": "Communities"
				},
				"networking": {
					"description": "Connect with other people living with rare diseases in order to share experiences, find support, ask questions and gain access to a rich network of supportive patient organisations.",
					"title": "Networking"
				},
				"title": "Features",
				"translation": {
					"description": "RareConnect helps people who live with rare diseases from around the world to connect by providing different translation services. We provide an integrated machine-translation service but also an additional human translation service to ensure quality communication between members of the network.",
					"title": "Translation"
				}
			},
			"howItWorks": {
				"description": "RareConnect is divided into disease specific online communities and discussion groups around topics of interest which may be disease specific or concern issues which touch on many disease areas.",
				"steps": {
					"first": "Find a community or a discussion group",
					"fourth": "Meet others and connect with them",
					"second": "Join a community or a conversation",
					"third": "Share your story or ask a question"
				},
				"title": "How it works"
			},
			"involvement": {
				"caption": "Beyond signing up and becoming a member of RareConnect, there are many other ways in which you or your organization can get involved in the platform",
				"moderators": {
					"button": "Contact us",
					"description": "Join our team of volunteer moderators",
					"title": "Become a Moderator"
				},
				"organizations": {
					"button": "Join now",
					"description": "Start a community for a rare disease in partnership with us",
					"title": "Patient Organizations"
				},
				"title": "Get Involved",
				"translators": {
					"button": "Contact us",
					"description": "Help us translate people’s stories in any language",
					"title": "Be a volunteer translator"
				}
			},
			"moreDetails": {
				"description": "Hosted by trusted patient advocates, RareConnect is a place where rare disease patients can connect with others globally. RareConnect is a safe environment where privacy is respected and where trusted information is shared via real patient representatives.",
				"section": {
					"dataProtection": {
						"description": "RareConnect has declared its activity with the French Data Protection Agency's CNiL as compliant with the European Directive on Data Protection as implemented into French legislation.",
						"title": "Data protection compliant"
					},
					"experiencedModerators": {
						"description": "Each community on RareConnect is moderated by a person living with a relevant rare disease and linked to a trusted patient group. Furthermore all moderators are trained in the use of our online communities charter and supported on a daily basis by a team of community managers.",
						"title": "Experienced moderators"
					},
					"nonForProfit": {
						"description": "The RareConnect team is made up of employees from the non-profit organizations: EURORDIS- Rare Diseases Europe and Care4Rare Canada. Funding for RareConnect comes from grants and corporate sponsorship. For more information about corporate sponsorship through EURORDIS, please visit eurordis.org/international.",
						"title": "Non-profit"
					},
					"patientLed": {
						"description": "RareConnect is a patient-led initiative. Patient organisations partner with RareConnect, itself an international patient organisation, to create communities and provide moderators from within their network.",
						"title": "Patient-led"
					},
					"secureCommunication": {
						"description": "All communication between you and RareConnect servers are encrypted using certified Secure Socket Layers (SSL). This means that even on public networks hackers cannot listen to or capture sensitive data.",
						"title": "Secure communication"
					},
					"whoWeAre": {
						"description": "The RareConnect team is an international team made up of researchers, community managers and software developers. The team is comprised of employees from EURORDIS and the Hospital for Sick Children. Together, this team’s mission is to fight against the impact of rare diseases on people’s lives by studying and developing better tools for disease treatment.",
						"title": "Who we are"
					}
				}
			},
			"partners": {
				"description": "RareConnect is operated or endorsed by the following partners who have partnered with us to promote the platform to their members. We recognise and thank them for their efforts.",
				"endorsing": {
					"title": "Partners endorsing & supporting RareConnect"
				},
				"operating": {
					"title": "Operating Partners"
				},
				"title": "Building a Community of Trust"
			}
		},
		"subtitle": "Start a community for a rare disease in partnership with us.",
		"title": "Connecting rare disease patients globally"
	},
	"languages": {
		"cs": "Czech",
		"de": "German",
		"en": "English",
		"es": "Spanish",
		"fa": "Farsi",
		"fr": "French",
		"it": "Italian",
		"ja": "Japanese",
		"null": "Unknown",
		"original": "original",
		"pt": "Portuguese",
		"ro": "Romanian",
		"ru": "Russian",
		"sh": "Serbian/Croatian",
		"uk": "Ukrainian"
	},
	"likes": {
		"actions": {
			"close": "Close"
		},
		"description": {
			"comment": {
				"multiple": "%{number} users have liked this comment",
				"single": "1 user has liked this comment"
			},
			"post": {
				"multiple": "%{number} users have liked this post",
				"single": "1 user has liked this post"
			}
		},
		"title": "Likes"
	},
	"login": {
		"facebook": {
			"error": "Facebook login failed"
		},
		"form": {
			"cancel": {
				"button": "Cancel"
			},
			"done": {
				"button": "Done"
			},
			"error": "The username/email or password is incorrect",
			"forgotPassword": {
				"error": "No account was found for this email or the email has not been verified",
				"hint": "Email",
				"instruction": "Please type the email associated with your RareConnect account below and we will email you link to reset your password.",
				"link": "Forgot password?",
				"success": "An email has been sent to %{email}, please follow the instructions included to reset your password",
				"title": "Reset your RareConnect password"
			},
			"login": {
				"hint": "Username or email"
			},
			"or": {
				"divider": "or"
			},
			"password": {
				"hint": "Password"
			},
			"send": {
				"button": "Send"
			},
			"signup": "Join now",
			"submit": {
				"button": "Continue with email"
			},
			"welcome": "Login to your RareConnect account"
		},
		"goToLogin": "Go to the login page",
		"google": {
			"error": "Google login failed"
		},
		"resetPassword": {
			"button": {
				"login": "Login now",
				"save": "Save"
			},
			"description": "Please enter your new password",
			"fields": {
				"password": "Password",
				"passwordConfirmation": "Confirm password"
			},
			"messages": {
				"failure": "Your password could not be reset at this time, please email admin@rareconnect.org",
				"passwordConfirmationError": "Your passwords do not match",
				"passwordError": "Your password must be at least 8 characters",
				"success": "Password successfully reset!",
				"urlError": "No token found, verify the link you were emailed. If you continue to experience problems please contact admin@rareconnect.org"
			},
			"title": "Password Reset"
		},
		"verifyEmail": {
			"button": {
				"home": "My profile"
			},
			"failure": {
				"otherThings": "In the meantime, here are some things you can do:",
				"title": "Error"
			},
			"messages": {
				"failure": "Your email could not be verified at this time, please email admin@rareconnect.org",
				"success": "Thank you for verifying your email. You are now able to receive email notifications and private messages from other members. To choose which types of emails you would like to receive, you can manage your preferences here:",
				"urlError": "No token found, verify the link you were emailed. If you continue to experience problems please contact admin@rareconnect.org"
			},
			"success": {
				"completeProfile": "Consider completing your profile by adding some information about yourself",
				"otherThings": "Here are some other things you can do:",
				"title": "Success!",
				"viewCommunities": "Find a community to join",
				"viewFeed": "Take a look at the latest posts"
			},
			"title": "Email Verification"
		}
	},
	"navbar": {
		"admin": {
			"label": "Admin"
		},
		"communities": {
			"label": "Communities"
		},
		"feed": {
			"label": "My Feed"
		},
		"feedback": {
			"label": "Contact"
		},
		"language": {
			"label": "Language"
		},
		"login": {
			"label": "Login"
		},
		"notifications": {
			"button": "See all",
			"empty": {
				"description": "No new notifications"
			},
			"label": "Notifications"
		},
		"profile": {
			"label": "My Profile"
		},
		"research": {
			"label": "My Studies",
			"settings": "My Studies Settings"
		},
		"search": {
			"close": "Close",
			"label": "Search",
			"placeholder": "Search for anything..."
		},
		"signup": {
			"label": "Sign up"
		},
		"user": {
			"account": {
				"label": "Account Settings"
			},
			"profile": {
				"label": "Edit My Profile"
			},
			"signOut": {
				"label": "Sign out"
			}
		}
	},
	"notifications": {
		"description": "Below are all the notifications you've received from communities you've subscribed to, users who have followed you, and discussions you've started or contributed to. If you would also like to receive these notifications as emails, please visit the account settings page:",
		"empty": "You have no notifications yet",
		"link": "Email Preferences",
		"section": {
			"older": "Older",
			"today": "Today",
			"unread": "New",
			"week": "This Week"
		},
		"title": "Notifications",
		"types": {
			"announcement": "RareConnect has posted an announcement",
			"commented": "%{username} commented on your post",
			"commented_thread": "%{username} commented on a post you also commented on",
			"followed": "%{username} started following you",
			"joined_subscribed_community": "%{username} joined the %{communityName} community",
			"liked": {
				"comment": "%{username} liked your comment",
				"post": "%{username} liked your post"
			},
			"post_to_followers": "%{username} posted in the %{communityName} community",
			"posted_in_subscribed_community": "%{username} posted in the %{communityName} community",
			"story_to_followers": "%{username} posted a new story"
		}
	},
	"pagination": {
		"fetch": {
			"button": "View More"
		}
	},
	"post": {
		"author": {
			"label": "By %{username}"
		},
		"commentCount": {
			"multiple": "Replies",
			"single": "Reply"
		},
		"expand": "Read More",
		"language": {
			"original": "originally written in %{lang}"
		},
		"likeButton": {
			"like": "Like",
			"likes": "Likes"
		},
		"menu": {
			"bookmark": {
				"add": {
					"error": "Failed to bookmark. Please try again later.",
					"label": "Bookmark Post",
					"link": "View bookmarks",
					"success": "Successfully bookmarked"
				},
				"remove": {
					"error": "Failed to unbookmark. Please try again later.",
					"label": "Unbookmark Post",
					"success": "Successfully unbookmarked"
				}
			},
			"delete": "Delete post",
			"edit": "Edit Post",
			"label": "More",
			"move": "Move Post",
			"pinning": {
				"add": {
					"error": "Failed to pin post",
					"label": "Pin Post",
					"success": "Successfully pinned post"
				},
				"remove": {
					"error": "Failed to unpin post",
					"label": "Unpin Post",
					"success": "Successfully unpinned post"
				}
			},
			"report": "Report Post",
			"viewReactions": "View Likes"
		},
		"permalink": {
			"button": {
				"label": "Permalink"
			}
		},
		"reply": {
			"button": {
				"label": "Reply"
			}
		}
	},
	"privacy": {
		"description": "Individual control and transparency of one’s personal information are core principles of the RareConnect platform. RareConnect respects and protects the privacy of people who use the website (www.rareconnect.org). \n\n## What information do we collect?\n\nRareConnect only collects unique information about you when you specifically and knowingly provide such information (for example, at the time of registration we collect your email address and month/year of birth, we also archive the content from posts). You are encouraged to use a unique username at the time of registration, and not an easily identifiable one (such as your name). By providing personal details you are consenting to their use in accordance with the intent of RareConnect, this policy and the Terms of Service. Such personal information will be used to identify you as a unique user, and the information will not be shared with any other entity or organization, unless you have specifically requested us to do so or we are required to do so by law.\n\n## How your information is used\n\nRareConnect uses data that you share on the platform in several ways, according to the sensitivity of the information and your privacy settings:\n\n- **Statistics:** aggregate demographic, health, and usage data may be shared publicly and included in presentations and reports. Examples:\n - Number of users in a particular community;\n - Average number of posts per user;\n - Location information where traffic originates from; and\n - Number of visitors on the site and number of visits.\n \n\n- **Translations:** textual content you share with the site may be sent to a third party translation service (such as Google Translate or Translators without Borders) over a secured connection. Examples:\n - Posts;\n - Comments; and,\n - Stories.\n\n\n- **Research:** RareConnect can be used to help you discover research studies that may be of interest. These studies will be posted on the individual Community pages and on the My Studies portal, and you will have the option of opting-in. None of your information will be used for research without your permission.  \n - \tWhen you enter the My Studies portal you will be shown a research portal Terms of Service and registration form. You will have to complete the registration form to be eligible to participate in the research studies. You will then have to consent to the terms of individual studies before being able to participate.  The data you enter through My Studies will be stored on a separate server from your RareConnect profile, to decrease the chances of you being identified in case of a security breach. \n\n\n- **User experience:** We use your preferences in your Account Settings to better your user experience at RareConnect. For example, in order to better tailor your community interaction, we send email notifications based on your preferences. \n\n\n- **Quality control:** RareConnect administrators may monitor site usage and content to improve the platform, fight spam, find bugs, and ensure behaviour adheres to the site’s Terms of Service. Examples:\n - IP history;\n - Site interactions;\n - Error reports, and,\n - User feedback.\n\n\n## Your Activity\n\nRareConnect uses Google Analytics to anonymously monitor how users move through the site, and uses analytics to improve user experience.\n\nRareConnect uses a feature, called “local storage.” Local storage is used to keep login sessions alive and to record the content contributions of logged-in users: posting, commenting, flagging, editing posts, joining communities, etc. If your computer does not support local storage, cookies will be used instead. Cookies store small amounts of data on your computer about your visit to our site.\n\n## Data security\n\nWe take data protection seriously. This site has security measures in place to protect the loss, misuse and alteration of the information in our control. Despite the mechanisms in place to keep all information secure and to protect your privacy, there is always a risk of a privacy breach. If a privacy breach occurs, RareConnect will take immediate steps to contain the breach, and contact you as soon as reasonably possible in order to inform you of the breach, explain what data may have been compromised and suggest steps you might consider taking in order to secure your personal information.\n\nRareConnect is not responsible for the privacy practices or the content of web sites external to the domain “RareConnect.org”.\n\n## Exporting your information\n\nYou can export a copy of your posted content from your RareConnect account if you want to back it up or use it outside of RareConnect at any time.  This can be done in your Account Settings.\n\n## Deleting your account\n\nYou can delete your account if you wish.  This can be done in your Account Settings. Please remember that anything you have posted may have been copied/quoted by others and used in their posts. As such, it may be impossible to delete everything that you have ever posted on RareConnect.  If you have any questions about this deleting content, you may contact: privacy@rareconnect.org\n\n## We are committed to data protection\n\nWe will continue to review our privacy policy and will notify you of any significant changes. We encourage you to periodically review this policy for the latest information on our privacy practices.\n\n## Who can I ask if I have additional questions?\n\nIf you have any questions about this privacy statement, the practices of this site, or your dealings with this website, you may contact: privacy@rareconnect.org",
		"title": "Privacy Policy"
	},
	"profile": {
		"avatar": {
			"remove": {
				"button": {
					"label": "Remove"
				}
			},
			"upload": {
				"button": {
					"label": "Upload"
				},
				"error": "Image upload failed",
				"sizeLimit": "Image exceeds size limit of 5MB",
				"success": "Image uploaded"
			}
		},
		"edit": {
			"description": {
				"label": {
					"organization": "Your organization description",
					"person": "A little bit about you"
				}
			},
			"error": "Error editing your profile",
			"explanation": {
				"organization": "Please describe your organization, your mission statement, and your geographic coverage to help people discover your organization and the work that you do.",
				"person": "The more details you add, the better we can connect you with people who share similar experiences to yours as well as providing you with more accurate and relevant content."
			},
			"gender": {
				"female": "Female",
				"label": "Your gender",
				"male": "Male",
				"other": "Other",
				"undisclosed": "Prefer not to say"
			},
			"geographic_scope": {
				"country": "Country",
				"global": "Global",
				"label": "Your geographic coverage",
				"locality": "City",
				"region": "Region",
				"unspecified": "Unspecified"
			},
			"language": {
				"label": "Language"
			},
			"location": {
				"disclaimer": "By sharing your location it can help facilitate discussion with people in your area. However, please remember that due to the rarity of some disorders it may be possible that you can be identified by adding your location as part of your profile.",
				"error": "Please select a valid location from the drop-down list",
				"label": "Your location"
			},
			"name": {
				"label": "Your organization name"
			},
			"success": "Profile saved",
			"visibility": {
				"global": {
					"disclaimer": "If you choose to make your profile publicly visible, you understand that your username and profile can be searched for and accessed by individuals who are not registered members of RareConnect.",
					"label": "Profile is visible to everyone (even Google)"
				},
				"label": "Your profile visibility",
				"users": {
					"label": "Profile is visible to users on RareConnect"
				}
			},
			"website": {
				"label": "Your website or blog"
			}
		},
		"name": {
			"badge": {
				"organization": {
					"tooltip": "Patient Organization"
				}
			}
		},
		"page": {
			"accountType": {
				"admin": "Admin",
				"member": "Member",
				"organization": "Organization"
			},
			"joined": "Joined"
		},
		"save": {
			"button": {
				"label": "Save changes"
			}
		},
		"summary": {
			"stats": {
				"followers": "Followers",
				"posts": "Posts"
			}
		},
		"tabs": {
			"activity": {
				"description": "Below is a list of all your posts on the site. This is an easy way to see your activity and track reactions from other RareConnect members.",
				"empty": "You have not posted anything yet",
				"label": "My Activity",
				"title": "My Activity"
			},
			"bookmarks": {
				"description": "Here you can see posts and comments that you've saved. Look in the \"more\" menu to bookmark posts!",
				"empty": {
					"description": "You have not bookmarked any posts or comments yet."
				},
				"label": "My Bookmarks",
				"title": "My Bookmarks"
			},
			"communities": {
				"description": "Below is a list of all the communities you have joined.",
				"empty": "You have not joined any communities yet",
				"header": "My communities"
			},
			"feed": {
				"communityLink": "View all communities",
				"description": "Below are the latest posts from people you follow and communities you are a part of. ",
				"empty": {
					"description": "Head over to the communities page to visit or join a community and find more people to follow."
				},
				"label": "My Feed",
				"title": "My Feed"
			},
			"network": {
				"empty": {
					"description": {
						"followers": "You do not have any followers. The more active you are on RareConnect, the more people will come across your profile.",
						"following": "You are not following anyone. Follow members to see their activity on your feed."
					}
				},
				"label": "My Network",
				"sections": {
					"followers": "Followers",
					"following": "Following"
				},
				"title": "My Network"
			},
			"stories": {
				"description": "Introduce yourself to other RareConnect members and share your experience. Your stories will appear in communities that you have joined.",
				"label": "My Stories",
				"title": "My Stories"
			}
		},
		"username": {
			"anonymize": "[ hidden ]"
		}
	},
	"reactions": {
		"deleted": {
			"comment": "This comment has recently been deleted",
			"post": "This post has recently been deleted"
		}
	},
	"report": {
		"actions": {
			"cancel": "Cancel",
			"submit": "Submit"
		},
		"description": "If so, please choose one of the following reasons.",
		"error": "Your report could not be processed at this time",
		"link": "Learn more",
		"reasons": {
			"harassmentBullying": "Harassment or bullying",
			"hate": "Hateful content",
			"medicalAdvice": "Giving medical advice",
			"salePromotion": "Sale or promotion of drugs",
			"selfInjury": "Self injury",
			"sharePersonalInfo": "Sharing personal information",
			"spam": "Spam"
		},
		"success": "Your report has been received successfully",
		"title": "Do you want to anonymously report this content?"
	},
	"search": {
		"empty": "Sorry, we couldn’t find any results for this search.",
		"filterCommunity": "Limit my search to the %{communityName} community",
		"label": "Search",
		"sidebar": {
			"comments": "Comments",
			"communities": "Communities",
			"other": "Other",
			"posts": "Posts",
			"profiles": "Profiles"
		},
		"title": "Search RareConnect",
		"titleWithCommunityName": "Search the %{communityName} community"
	},
	"session": {
		"expired": {
			"error": "Your session has expired"
		}
	},
	"signup": {
		"stepper": {
			"account": {
				"confirmPassword": "Confirm Password",
				"description": {
					"organization": "Please register with your email below:",
					"person": "Do you already have an account on one of these sites? Click the logo to register:"
				},
				"existingAccount": "Already have an account?",
				"finish": "Please fill in the rest of your information in order to complete the signup process.",
				"form": "Or you can register with your email and password below:",
				"password": "Password",
				"passwordError": "Your password must be at least 8 characters",
				"passwordMatchError": "Your password does not match",
				"stepLabel": "Account",
				"title": "Please provide your account details"
			},
			"buttons": {
				"back": "back",
				"next": "next"
			},
			"details": {
				"birthday": {
					"description": "Please provide your date of birth. This will be kept private.",
					"invalid": "Please enter a valid date of birth",
					"label": "Date of birth:",
					"monthInvalid": "Invalid month",
					"title": "Enter your date of birth",
					"yearInvalid": "Invalid year"
				},
				"email": {
					"description": "Please provide an email address to contact you below. Your email is important for resetting your password and you can use it to log in as well. Your email address will be kept private and will only be visible by RareConnect.org administrators.  Your email will not be shared with any third parties.",
					"exists": "This email is already associated with a RareConnect account",
					"invalid": "Please enter a valid email address",
					"label": "Email",
					"title": "Provide an email"
				},
				"stepLabel": "Details",
				"username": {
					"descriptionOrganization": "Please provide a username below. Your username should be unique and allow users to identify your organization easily. You can use letters (a-z), numbers (0-9), and underscores (_).",
					"descriptionPerson": "Please pick a username (you can change it later). Your username will be public, so please pick a username that does not identify you if you wish to remain anonymous. You can use letters (a-z), numbers (0-9), and underscores (_).",
					"exists": "Sorry, this username is already taken",
					"forbidden": "This username is forbidden.",
					"invalid": "Please use only letters (a-z), numbers (0-9), and underscores (_)",
					"label": "Username",
					"title": "Pick a username"
				}
			},
			"exit": {
				"buttons": {
					"cancel": "Cancel",
					"exit": "Exit"
				},
				"confirmation": "Are you sure you want to exit the signup process?",
				"declineTerms": "In order to use RareConnect you must accept the terms of service. If you have any questions about the terms of service please contact us at privacy@rareconnect.org",
				"title": "Exit sign up?"
			},
			"profile": {
				"description": "Welcome to the registration section of RareConnect.org. In just a few simple steps you will join the supportive social network for rare disease patients. Look around, join a community and get connected! If you already have an account, please click the log in link:",
				"login": "login",
				"oauth": {
					"message": "Sign up through:",
					"or": "OR"
				},
				"organization": {
					"description": "Patient organizations are integral to the success of RareConnect. We rely on patient organizations to help provide disease expertise and share information about their programs, services, and events.",
					"label": "Organization"
				},
				"person": {
					"description": "Connect with others who understand you. Learn about research and the latest treatments. See what advocacy organizations are doing around the world. Find helpful resources and information from experts.",
					"label": "Individual"
				},
				"stepLabel": "Profile",
				"title": "Create your RareConnect Account",
				"type": {
					"prompt": "I am a..."
				}
			},
			"returningUser": {
				"buttons": {
					"okay": "okay"
				},
				"description": "EURORDIS and Care4Rare Canada have partnered up to maintain and improve the RareConnect website.  Although your user experience will not change, we have updated our Terms of Service.  You can read the full Terms of Service here. To make it easier, here is a summary of the changes:\n\n  - We’ve updated our mission statement to emphasize the empowerment of the rare disease community\n  - We’ve updated our social media terms\n  - We’ve reinforced user commitments to RareConnect\n  - We’ve emphasized that content on RareConnect should not be a substitute for professional medical advice and you should always consult a physician or health care provider with any questions you may have.\n\nIf you have any questions, please email us at privacy@rareconnect.org",
				"title": "We've updated our Terms of Service!"
			},
			"terms": {
				"accept": "I accept",
				"checkbox": "I agree to these terms and this use of my data",
				"checkboxAlternate": "I agree to these terms",
				"decline": "I do not accept",
				"hint": "Please scroll through to read and accept the terms of service.",
				"remove": {
					"description": "If you do not accept RareConnect's new Terms of Service, your account will be removed. If you change your mind you will be required to register for a new account. If you would like to discuss the terms of service contact privacy@rareconnect.org",
					"title": "Remove your account?"
				},
				"stepLabel": "Terms"
			}
		}
	},
	"termsOfService": {
		"description": "\n### The English Terms of Service are the official version. Translations from English may also be available.\n\nOur mission is to empower the rare disease community by bringing people together to share experiences and support one another.\n\nTo advance this mission, RareConnect will:\n-\tallow members to find support by connecting with a community of people with similar symptoms and experiences;\n-\thelp patient advocacy organizations engage with and support their communities; \n-\tstrive to provide a safe and supportive environment for its members; and,  \n-\thelp members to discover research studies that may be of interest.\n\nHundreds of volunteer moderators and members of patient advocacy organizations manage these communities, with the support of several full-time administrators. \n\nContent on RareConnect is contributed by users on the site and is not medical advice. The contents of RareConnect, (such as text, graphics, images, information obtained from third parties, etc), and other material contained on RareConnect (hereinafter \"Content\") are for informational purposes only. The Content is not intended to be a substitute for professional medical advice, diagnosis, or treatment. Always seek the advice of your physician or other qualified healthcare provider with any questions you may have regarding a medical condition. Never disregard professional medical advice or delay in seeking such advice because of something you have read on RareConnect. \n\nReliance on any information and/or Content provided by RareConnect members, moderators, administrators or others appearing on RareConnect at the invitation of the RareConnect team, or other visitors or users to RareConnect, is solely at your own risk. Content and links appearing on this site are not endorsed by the RareConnect team. The RareConnect team takes no responsibility for, does not expressly or implicitly endorse, and does not assume any liability for, any content on RareConnect.  Further, there are no representations or warranties of any kind, express or implied with respect to any content.\n\nSome RareConnect members may choose to participate in research studies.  Information about such studies will be made available through Community pages. Any information submitted by members through the My Studies portal (which becomes visible when studies are available) will only be shared with researchers who have received appropriate Research Ethics Board approval for their proposed study.  My Studies participation is completely optional and will not affect your participation in the RareConnect social platform.  \n\nPlease visit ABOUT to learn more about RareConnect and the services we offer.\n\n\n## Our Data Collection Policy\nTo provide services through RareConnect, we must collect and use personal data. We detail our practices in our Privacy Policy section, which you must agree to in order to use RareConnect. We also encourage you to review your personal privacy options in your Account Settings.\n\nIf you have any questions about our privacy policy, please contact privacy@rareconnect.org\n\n## Your Privacy Choices \nBefore posting a message, every member should be aware that posting might share possibly confidential information to be linked to personal identifiers (the user name and profile information a member chooses to provide).\nThis information will become available to others and no one knows the identity or the motivation of those accessing the information. Posted messages can also be found by search engines (e.g., Google).\nIt is therefore important to be careful when disseminating personal information (for example name or phone number) or when it concerns the privacy of relatives, especially children.\nIn addition, every member should be aware that some of their own posts can be included in the responses of other participants, and can, therefore, never be removed from the archives of this online community.\nIt is advisable to weigh the potential benefits of participation in this online community with attendant risks to the confidentiality of information.\nCareful consideration should be given by users before agreeing to disclose location information on the community map. Due to the nature of the diseases as being rare and the possible isolation of members, by disclosing location information, it may be possible that users can be identified.  If users choose to add their location to the community map, they should be aware that identification may naturally result.\n\n## RareConnect Social Media\nIf you choose to make your visibility setting public (for stories and posts), you understand that your content can be accessed by individuals who are not registered members of RareConnect and can also be found by a simple search engine. Additionally, RareConnect may share your publicly posted content on RareConnect’s social media pages, and may contact you for further details or additional uses.\n\nIf your visibility settings are private, visible only to members of RareConnect, you may be contacted by a RareConnect administrator for permission to post your content on RareConnect’s social media pages.  If you choose not to share your posts on social media, your user experience on RareConnect will not be affected. \n\n## Your Commitments to RareConnect\nWe are committed to keeping RareConnect a safe and supportive environment for everyone, so in using RareConnect you are making the following commitments:\n\n### You will not register under various pseudonyms in order to post multiple messages.\n\n### You will not offer medical advice:\n\nMessages on forums must be for informational purposes only.  You must not offer, or be perceived to be offering, medical advice.\n\nThe information posted by users is often partial, and may only cover one aspect of a person’s illness(es) or experience(s).  You will avoid generalizing from personal experience(s) and will clearly indicate if and when you are sharing your own personal story. \n\nAny information relating to therapy or diagnosis, even if it comes from users who have ‘expert knowledge’ of their disease, must be received with caution.  Only your physician is authorized to offer and/or confirm medical diagnosis and/or advice.  \n\n### You will not recommend treatments:\n\nTreatment options should only be provided by a qualified physician and should depend on the particulars of each individual’s medical history. The treatment choices of other users must be respected and forum members should never claim that a specific treatment is the only one that is effective for a particular disease.\n\nForum members must also be careful when sharing their experience(s) with products and/or practices that have not been properly evaluated for the disease or symptom that is the subject of discussion within the forum. \n\n### You will not post any unauthorized advertising messages:\n\nAny form of advertising is not allowed in the forums or in direct messaging. This applies with respect to treatments, clinical trials, registries, physicians, care facilities, etc.\n\nSome weblinks may be shared, but only those that link to content which conforms with these Commitments that you are making to RareConnect (for example, you may link to personal pages that meet RareConnect standards, or you may link to websites that provide scientifically supported information that is relevant to the forum you are in). \n\n ### You will be respectful of other members. You will do this by: \n\n- respecting the opinions, beliefs, and differences of other members;\n- being polite and keeping a measured tone in all exchanges;\n- refraining from undermining the morale of other members; \n- not posting hateful, threatening, violent or otherwise inappropriate content;\n- not spreading rumors or content that may harm or endanger the health and safety of others.\n\n### You will not post content or engage in behaviour that is illegal:\n\n All members must comply with the laws of their country. Particular emphasis must be on avoiding the spread of illegal content, respecting the privacy of other members, and protecting copyright and other intellectual property laws.\n\n\n### You will not collect users’ content or information from this website for your own personal or commercial use. This applies to any and all means of collection (e.g. manual, automated, direct and/or indirect). \n\nModerators and administrators reserve the right to remove and disconnect any member or participant who violates these restrictions and commitments and this may be done in their sole and exclusive discretion.\n\nRareConnect Administrators may, in accordance with their legal obligations, act quickly to remove data or make access impossible when they have knowledge from a third party that a member has circulated illegal content through RareConnect.",
		"title": "Terms of Service"
	},
	"test": "test",
	"translate": {
		"error": "The content could not be translated at this time",
		"label": "Translate to %{language}"
	},
	"unsubscribe": {
		"description": "You have successfully unsubscribed from email notifications. If you would like to enable or customize your email notifications, please adjust your preferences in [account settings](%{url})",
		"error": {
			"description": "We cannot process your request to unsubscribe at this time. You can try again later, or email us at team@rareconnect.org",
			"title": "Oops, something went wrong!"
		},
		"title": "Successfully Unsubscribed"
	},
	"user": {
		"network": {
			"follow": {
				"button": {
					"label": "Follow"
				},
				"error": "Failed to follow user",
				"success": "Successfully followed user"
			},
			"subscription": {
				"emailPrefs": "Email preferences",
				"notSubscribed": "Followed",
				"subscribe": {
					"error": "Failed to subscribe",
					"label": "Subscribe",
					"success": "Successfully subscribed"
				},
				"subscribed": "Subscribed",
				"unsubscribe": {
					"error": "Failed to unsubscribe",
					"label": "Unsubscribe",
					"success": "Successfully unsubscribed"
				}
			},
			"unfollow": {
				"button": {
					"label": "Unfollow"
				},
				"error": "Failed to unfollow user",
				"success": "Successfully unfollowed user"
			}
		},
		"tabs": {
			"activity": {
				"description": "Below is a list of %{username}'s posts. If you follow %{username}, their posts will appear in your feed.",
				"empty": "%{username} has not posted anything yet.",
				"label": "Activity",
				"title": "Activity"
			},
			"communities": {
				"description": "Below is a list of all the communities %{username} has joined.",
				"empty": "%{username} has not joined any communities yet",
				"header": "%{username}'s communities"
			},
			"network": {
				"empty": {
					"description": {
						"followers": "%{username} does not have any followers yet.  Click the follow button if you'd like to follow them.",
						"following": "%{username} is not following any users yet."
					}
				},
				"label": "Network",
				"title": "Network"
			},
			"stories": {
				"description": "Below is a list of %{username}'s stories. If you follow %{username}, their stories will appear in your feed.",
				"empty": "%{username} has not shared any stories yet.",
				"label": "Stories",
				"title": "Stories"
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/en.json
// module id = 1027
// module chunks = 0